import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail } from 'lucide-react';

const CTASection: React.FC = () => {
  return (
    <section className="relative py-16 bg-navy-900 text-white overflow-hidden">
      {/* Subtle decorative shapes */}
      <div className="absolute -top-24 -right-24 w-80 h-80 bg-navy-800/50 rounded-full blur-3xl"></div>
      <div className="absolute -bottom-24 -left-24 w-80 h-80 bg-orange-500/10 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-center">
          <div className="lg:col-span-3">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className="text-3xl md:text-4xl font-bold mb-4 text-white"
            >
              Klaar voor vakkundige elektrotechnische diensten?
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="text-gray-200 mb-6 lg:mb-0 text-lg"
            >
              "Waar de service van een ander stopt, begint onze pas."
              <br />
              Neem vandaag nog contact op voor een vrijblijvende offerte!
            </motion.p>
          </div>
          <div className="lg:col-span-2 flex flex-col sm:flex-row gap-4">
            <motion.a
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.3 }}
              href="tel:0383336549"
              className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-3.5 rounded-full font-semibold transition-all duration-300 flex items-center justify-center shadow-lg shadow-orange-500/30 hover:shadow-xl hover:shadow-orange-500/40 hover:-translate-y-0.5"
            >
              <Phone size={18} className="mr-2" />
              Bel direct
            </motion.a>
            <motion.a
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.4 }}
              href="/contact"
              className="bg-white hover:bg-gray-100 text-navy-800 px-6 py-3.5 rounded-full font-semibold transition-all duration-300 flex items-center justify-center shadow-md hover:shadow-lg hover:-translate-y-0.5"
            >
              <Mail size={18} className="mr-2" />
              Stuur bericht
            </motion.a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
